import api from '../../../api';
import { error, finish } from '../../../modules/user/actions/switch-univers';
import { finish as finishLogin } from '../../../modules/user/actions/login';

export function request( dispatch, { universe, token } ) {
    if ( !universe || !token ) {
        return;
    }

    api.post( `/session/universe-switch`, {
        universe,
        token
    } ).then(
        data => {
            dispatch( finishLogin( data ) );
            dispatch( finish() );
        },
        () => dispatch( error() )
    );
}
